import { RecordManagmentPopup } from '@aibees/elephant/components';
import { useViewRecordsPopoverStore } from '@aibees/elephant/store/view-records-popover';
import { useMediaQuery } from '@mui/material';
import { memo, useLayoutEffect } from 'react';

export const ViewRecordsPopover = memo(function ViewRecordsPopover() {
  const viewRecordsPopover = useViewRecordsPopoverStore();

  const isSmall = useMediaQuery('(max-width:1200px)');

  useLayoutEffect(() => {
    viewRecordsPopover.setVisible(true);
    return () => viewRecordsPopover.setVisible(false);
  }, [viewRecordsPopover.setVisible]);

  useLayoutEffect(() => {
    viewRecordsPopover.setCompact(isSmall);
  }, [viewRecordsPopover.setCompact, isSmall]);

  if (!viewRecordsPopover.open) return null;

  return <RecordManagmentPopup state={viewRecordsPopover} type="lists" />;
});
